import React from 'react';
import { _ } from '../../../functions/translator';

class EndInfo extends React.Component{

    render(){

        let endValue = this.props.cardsGroup.attributes.end;
        let endDefinition = _("Final");

        if (this.props.customcard) {
            if (!this.props.customcard.attributes.end) return <div></div>;
            endDefinition = this.props.customcard.attributes.end;
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ endDefinition }</p>
                <span className='text card-description'>{ endValue }</span>
            </div>
        );
    }
}

export default EndInfo;